import * as THREE from 'three';
import { G, M, TINT, HP, K_BEV, glowMat, mesh, bevel, plate, rib, mergeBones, stages, boneG } from './kit';
/* ============================================================
   BRÜCKE 橋 —— BOSS・複合雙柱
   ============================================================

   剪影：拱門・玩家從下面穿過
   階段：'P1 站立・門下是唯一通道','P2 右柱折斷・整座傾斜','P3 倒下・變成橫躺的長堡壘'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-16 BRÜCKE 橋 ── 複合式：兩根柱子各自是一段血量，你從中間穿過去。
   P1 拱門站立，門下是唯一的安全通道（頂樑會往下打）。
   P2 右柱折斷，整座橋往那側傾 —— 通道歪掉，但頂樑終於降到打得到的高度。
   P3 整座倒下，變成一條橫躺在場上的長堡壘，砲口全部朝上。
   場地本身被牠改變了兩次，這是這隻存在的理由。 */
export function buildBrucke(){
  var GLA = glowMat(TINT.amb.hex, 2.2), GL = glowMat(TINT.red.hex, 2.0);
  var root = new THREE.Group(), i, k;
  var frame = boneG(root, 0, 0, 0);
  var pillars = [];
  for (k = 0; k < 2; k++){
    var sx = k ? 5.20 : -5.20;
    var pl = boneG(frame, sx, 0.90, 0);
    pl.add(bevel(M.dark,  2.60, 1.60, 2.80, [0,-0.20,0]));
    pl.add(plate(M.armor, 2.80, 0.60, 1.50, [0, 0.50, 0.70], -0.32));
    pl.add(mesh(G.bev, M.armor, [1.90*K_BEV,6.20,1.90*K_BEV], [0, 3.90, 0]));
    pl.add(rib (M.armor, 0.16, 5.60, 0.16, [ 0.86, 3.90, 0.70]));
    pl.add(rib (M.armor, 0.16, 5.60, 0.16, [-0.86, 3.90, 0.70]));
    pl.add(mesh(G.tor, M.trim, [2.30,2.30,0.44], [0, 6.60, 0], [HP,0,0]));
    var pg = mesh(G.box, GL, [0.20,4.60,0.16], [0, 3.90, 1.02]);
    pg.userData.noMerge = 1; pl.add(pg);
    pillars.push(pl);
  }
  var span = boneG(frame, 0, 7.60, 0);
  span.add(mesh(G.box, M.dark,  [11.6,1.10,2.20], [0,0,0]));
  span.add(plate(M.armor, 12.0, 0.50, 1.20, [0, 0.52, 0.60], -0.30));
  span.add(rib  (M.armor, 12.2, 0.14, 0.14, [0, 0.74, 0.16], -0.30));
  var guns = [];
  for (i = 0; i < 5; i++){
    var gp = boneG(span, (i-2)*2.30, -0.60, 0.30);
    gp.add(mesh(G.cyl, M.armor, [0.44,1.50,0.44], [0,-0.60,0]));
    var gm = mesh(G.tor, GLA, [0.74,0.74,0.55], [0,-1.34,0], [HP,0,0]);
    gm.userData.noMerge = 1; gp.add(gm);
    guns.push(gp);
  }
  root.userData.rig = {frame:frame, pillars:pillars, span:span, guns:guns, GLA:GLA, GL:GL};
  return mergeBones(root);
}
export function updBrucke(rig, o, dt){
  stages(rig, o, dt, 1.5);
  var s1 = rig.s1, s2 = rig.s2, i;
  rig.pillars[1].scale.y = 1 - 0.62*s1;
  rig.pillars[1].visible = s2 < 0.55;
  rig.pillars[0].scale.y = 1 - 0.30*s2;
  rig.frame.rotation.z = -0.30*s1*(1-s2) - 1.16*s2;   // 傾斜 → 整個倒下
  rig.frame.position.y = -0.20*s1 + 1.80*s2;
  rig.frame.position.x = 1.40*s2;
  rig.span.position.y  = 7.60 - 1.90*s1;
  for (i = 0; i < 5; i++){
    rig.guns[i].rotation.x = (o.tel*0.30 - o.atk*0.40);
    rig.guns[i].rotation.z = 1.16*s2 + 0.30*s1*(1-s2);  // 倒下之後砲口轉回朝上
  }
  rig.GLA.emissiveIntensity = 2.2 + 3.0*o.tel + 6*o.atk*(1-o.atk) + 1.4*s2;
  rig.GL.emissiveIntensity  = 2.0 - 1.2*s1 + 2.0*o.tel;
}